import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CloseActionComponent } from './close-action.component'

import { ButtonModule } from '../button/button.module';
import { IconModule } from '../icon/icon.module';

@NgModule({
  declarations: [CloseActionComponent],
  imports: [CommonModule, ButtonModule, IconModule],
  exports: [CloseActionComponent],
})
export class CloseActionModule {}